import React from 'react'

const Promote = () => {
  return (
    <div className="border-2 p-4 flex flex-col w-max rounded-10 items-center mx-auto mt-8">
        <img className="h-[60px] w-[60px] object-cover rounded-full" src='error.png' alt="default profile"/>
        <h1 className="text-19">First Name Last Name</h1>
        <p className='text-blue-500'>Company Name</p>
        <p>Position</p>
        <p>(###) ### - ####</p>
    </div>
  )
}

export default Promote